var map = {
	"./fetish.svg": 757,
	"./fetish_avatar.svg": 3403,
	"./gays.svg": 2610,
	"./gays_avatar.svg": 8974,
	"./kaufmich.png": 920,
	"./kaufmich_avatar.png": 1258,
	"./poppen.svg": 7948,
	"./poppen_avatar.svg": 5352
};

function webpackAsyncContext(req) {
	return Promise.resolve().then(() => {
		if(!__webpack_require__.o(map, req)) {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		}

		var id = map[req];
		return __webpack_require__.t(id, 1 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 1222;
module.exports = webpackAsyncContext;